"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _actions = require("./actions");

var _mergeWithCollectionOfType = _interopRequireDefault(require("settings-ui-sdk/utils/mergeWithCollectionOfType"));

var _MembershipEmail = _interopRequireDefault(require("./MembershipEmail"));

var initialState = (0, _immutable.Map)({
  emails: (0, _immutable.Map)()
});

var _default = (0, _fluxActions.handleActions)((0, _defineProperty2.default)({}, _actions.FetchMembershipEmailsActionTypes.SUCCESS, function (state, action) {
  return state.updateIn(['emails'], function (templates) {
    return (0, _mergeWithCollectionOfType.default)(_MembershipEmail.default, action.payload.data.objects, templates);
  });
}), initialState);

exports.default = _default;
module.exports = exports.default;